import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Layout from '../../components/Layout';
import { Card, CardContent } from '../../components/ui/card';
import { paymentsAPI } from '../../services/api';
import { CheckCircle, Loader } from 'lucide-react';
import { Button } from '../../components/ui/button';

const BorrowerPaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking');
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (sessionId) {
      pollPaymentStatus();
    }
  }, [sessionId, attempts]);

  const pollPaymentStatus = async () => {
    if (attempts >= 5) {
      setStatus('timeout');
      return;
    }

    try {
      const response = await paymentsAPI.getPaymentStatus(sessionId);
      if (response.data.status === 'paid') {
        setStatus('success');
      } else {
        setTimeout(() => setAttempts(attempts + 1), 2000);
      }
    } catch (error) {
      setTimeout(() => setAttempts(attempts + 1), 2000);
    }
  };

  return (
    <Layout title="Payment Status">
      <div className="max-w-md mx-auto">
        {status === 'checking' && (
          <Card>
            <CardContent className="py-12 text-center">
              <Loader className="w-12 h-12 mx-auto mb-4 text-blue-600 animate-spin" />
              <p className="text-lg font-medium">Processing your payment...</p>
              <p className="text-slate-600 mt-2">Please wait while we confirm your payment.</p>
            </CardContent>
          </Card>
        )}

        {status === 'success' && (
          <Card>
            <CardContent className="py-12 text-center">
              <CheckCircle className="w-16 h-16 mx-auto mb-4 text-green-600" />
              <h2 className="text-2xl font-bold text-green-700 mb-2">Payment Successful!</h2>
              <p className="text-slate-600 mb-6">Your upfront intake fee has been processed. Your deal is now being reviewed by our admin team.</p>
              <Button onClick={() => navigate('/borrower')} data-testid="goto-dashboard-button">
                Go to Dashboard
              </Button>
            </CardContent>
          </Card>
        )}

        {status === 'timeout' && (
          <Card>
            <CardContent className="py-12 text-center">
              <p className="text-lg font-medium text-slate-700 mb-2">Payment verification in progress</p>
              <p className="text-slate-600 mb-6">We're still processing your payment. Please check your email for confirmation.</p>
              <Button onClick={() => navigate('/borrower')}>
                Go to Dashboard
              </Button>
            </CardContent>
          </Card>
        )}
      </div>
    </Layout>
  );
};

export default BorrowerPaymentSuccess;